import { Component, HostBinding, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PrAliveComponent } from '@app/components/pr-alive/pr-alive.component';
import { EaVariant } from '@app/components/pr-display';
import { PrTabsItem } from '../model/pr-tabs';

@Component({
  selector: 'pr-tabs-item',
  templateUrl: './pr-tabs-item.component.html',
  styleUrls: ['./pr-tabs-item.component.scss'],
  standalone: false,
})
export class PrTabsItemComponent extends PrAliveComponent {
  @Input() tab: PrTabsItem;
  @Input() withPlus: boolean = true;
  @Input() variant: EaVariant;

  constructor(private router: Router) {
    super();
  }

  @HostBinding('class.pills') get isPills(): boolean {
    return this.variant === EaVariant.pills;
  }

  get current() {
    return this.router.url == this.tab.url;
  }
}
